import React,{Component} from 'react';


class Modal extends Component{
   
    

    render() {

        return (
            <div id={this.props.id} className="modal fade" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* Modal Header -->*/}
                        <div className="modal-header">
                            <h2><strong>{this.props.title}</strong></h2>
                        </div>
                        {/*<!-- END Modal Header -->*/}

                        {/*<!-- Modal Body -->*/}
                        <div className="modal-body">
                            {this.props.children}
                        </div>
                        {/*<!-- END Modal Body -->*/}
                    </div>
                </div>
            </div>
        );
    }
}

export default  Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js